import FlagIcon from '@mui/icons-material/Flag';
import { FilterList, FilterListItem } from 'react-admin';

import { CreatedByUserFilter } from '@/components/filters/CreatedByUserFilter';

export const QuoteJobFolderListFilter = () => (
    <CreatedByUserFilter searchPlaceholder="Search job folders">
        <FilterList label="Estimate" icon={<FlagIcon />}>
            <FilterListItem
                label="Pending estimate to send"
                value={{ informative_status: 'is_estimate_sent' }}
            />
        </FilterList>
    </CreatedByUserFilter>
);
